import React from 'react';

import { library } from '@fortawesome/fontawesome-svg-core';

import * as solid from '@fortawesome/pro-solid-svg-icons';
import * as regular from '@fortawesome/pro-regular-svg-icons';
import * as light from '@fortawesome/pro-light-svg-icons';
import * as duotone from '@fortawesome/pro-duotone-svg-icons';

library.add(
  // solid icons
  solid.faFolder,
  solid.faFolders,
  solid.faSearch,
  solid.faBell,
  solid.faCircle,
  solid.faSquare,
  solid.faPen,
  solid.faChevronUp,
  solid.faChevronLeft,
  solid.faChevronDown,
  solid.faChevronRight,
  solid.faBars,
  solid.faExclamationCircle,
  solid.faStar,
  solid.faBan,
  solid.faArrowAltSquareLeft,
  solid.faDesktopAlt,
  solid.faEllipsisV,
  solid.faPlusCircle,
  solid.faArrowLeft,
  solid.faTrash,
  solid.faPlane,
  solid.faExclamation,
  solid.faRotateLeft,
  solid.faLock,
  solid.faCircleXmark,
  solid.faPlus,
  solid.faMemoCircleCheck,
  solid.faEarthEurope,
  solid.faUserTie,
  solid.faUser,
  solid.faUserCircle,
  solid.faUserShield,
  solid.faIdBadge,
  solid.faInbox,
  solid.faLockOpen,
  solid.faAnglesLeft,
  solid.faAnglesRight,
  solid.faDiagramProject,
  solid.faHome,
  solid.faSignInAlt,
  solid.faSignOutAlt,
  solid.faAddressCard,
  solid.faHashtag,
  solid.faLayerPlus,
  solid.faLayerMinus,
  solid.faGripVertical,
  solid.faLevelUpAlt,

  //regular icons
  regular.faFolder,
  regular.faFolderPlus,
  regular.faFolderMinus,
  regular.faChevronUp,
  regular.faChevronLeft,
  regular.faChevronDown,
  regular.faChevronRight,
  regular.faBell,
  regular.faHighlighter,
  regular.faHighlighterLine,
  regular.faFolderTree,
  regular.faShareSquare,
  regular.faFileUser,
  regular.faFileAlt,
  regular.faFileCheck,
  regular.faPrint,
  regular.faFileDownload,
  regular.faFolderDownload,
  regular.faDownload,
  regular.faFilePlus,
  regular.faFileMinus,
  regular.faRedoAlt,
  regular.faBorderAll,
  regular.faHistory,
  regular.faEllipsisV,
  regular.faCircle,
  regular.faSquare,
  regular.faBars,
  regular.faTrash,
  regular.faTimes,
  regular.faUserPlus,
  regular.faUser,
  regular.faUserCircle,
  regular.faUserShield,
  regular.faIdBadge,
  regular.faInfoCircle,
  regular.faTimes,
  regular.faTimesCircle,
  regular.faExpandAlt,
  regular.faCompressAlt,
  regular.faEye,
  regular.faCheck,
  regular.faPen,
  regular.faArrowAltFromLeft,
  regular.faArrowAltToRight,
  regular.faSearch,
  regular.faCopy,
  regular.faStar,
  regular.faFileUpload,
  regular.faFolderUpload,
  regular.faStar,
  regular.faBan,
  regular.faTrashRestore,
  regular.faPlusCircle,
  regular.faHome,
  regular.faDesktopAlt,
  regular.faArrowLeft,
  regular.faLevelDown,
  regular.faPlane,
  regular.faExclamation,
  regular.faCircleXmark,
  regular.faRotateLeft,
  regular.faCog,
  regular.faEnvelope,
  regular.faUserTie,
  regular.faUserCog,
  regular.faClone,
  regular.faShareFromSquare,
  regular.faPaperPlane,
  regular.faEllipsisH,
  regular.faGridDividers,
  regular.faSearchPlus,
  regular.faSearchMinus,
  regular.faRedo,
  regular.faBoxArchive,
  regular.faPenLine,
  regular.faSquarePlus,
  regular.faRectangleHistoryCirclePlus,
  regular.faArrowDown19,
  regular.faRepeat,
  regular.faCircleCheck,
  regular.faStopwatch,
  regular.faEnvelopeOpenText,
  regular.faFilterList,
  regular.faUserCheck,
  regular.faMemo,
  regular.faPaperPlane,
  regular.faComments,
  regular.faSpinnerThird,
  regular.faLock,
  regular.faSquareDashedCirclePlus,
  regular.faUpFromBracket,
  regular.faCube,
  regular.faCubes,
  regular.faCubesStacked,
  regular.fa360Degrees,
  regular.faInbox,
  regular.faLockOpen,
  regular.faPaperclip,
  regular.faAnglesLeft,
  regular.faAnglesRight,
  regular.faDiagramProject,
  regular.faHome,
  regular.faSignInAlt,
  regular.faSignOutAlt,
  regular.faAddressCard,
  regular.faBriefcase,
  regular.faPlus,
  regular.faFileEdit,
  regular.faTrophy,
  regular.faHashtag,
  regular.faLayerPlus,
  regular.faLayerMinus,
  regular.faGlobe,
  regular.faObjectUngroup,
  regular.faBadgeCheck,
  regular.faTriangleExclamation,

  //light icons
  light.faFolders,
  light.faEllipsisV,
  light.faSearchPlus,
  light.faSearchMinus,
  light.faRedo,
  light.faTimes,
  light.faCube,
  light.faCubes,
  light.faCubesStacked,
  light.faHashtag,
  light.faLayerPlus,
  light.faLayerMinus,

  //duotone icons
  duotone.faFolders,
  duotone.faFolderOpen,
  duotone.faFile,
  duotone.faFileWord,
  duotone.faFilePdf,
  duotone.faFilePowerpoint,
  duotone.faFileImage,
  duotone.faFileVideo,
  duotone.faFileSpreadsheet,
  duotone.faFileArchive,
  duotone.faFileCsv,
  duotone.faFileUpload,
  duotone.faFileAlt,
  duotone.faCheckSquare,
  duotone.faMinusSquare,
  duotone.faMinusCircle,
  duotone.faCheckCircle,
  duotone.faHouse,
  duotone.faArchive,
  duotone.faInbox,
  duotone.faStar,
  duotone.faTasksAlt,
  duotone.faShareAltSquare,
  duotone.faQuestionSquare,
  duotone.faSlidersHSquare,
  duotone.faBoxUsd,
  duotone.faUserTie,
  duotone.faFolderTree,
  duotone.faTrash,
  duotone.faToggleOn,
  duotone.faToggleOff,
  duotone.faMobile,
  duotone.faCog,
  duotone.faGavel,
  duotone.faHouse,
  duotone.faCube,
  duotone.faCubes,
  duotone.faCubesStacked,
  duotone.faHashtag,
  duotone.faLayerPlus,
  duotone.faLayerMinus,
  duotone.faMap,
  duotone.faMapLocationDot,
  duotone.faMapLocation,
  duotone.faLayerGroup
);

function Icons() {
  return <div>{/* blank */}</div>;
}

export default Icons;
